import React from "react"
import { Link } from "react-router-dom"
import { SVGicon } from "../../../styleGuide/SVGicon/SVGicon"
import LogoWithoutText from "../../../assets/images/logos/logo-metropolis-symbol.svg";
import './LandingPageFooter.css'

export const LandingPageFooter = () => {
    return (
        <>
            <footer>
                <div className="landing-footer-links-container">
                    <div className="mtp-container">
                        <div className="landing-footer-row">
                            <div className="landing-footer-col">
                                <div className="landing-footer-link-box">
                                    <h6>Why Glassdoor</h6>
                                    <div className="landing-footer-link-list">
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">How it Works</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">The Glassdoor Difference</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">What is Employer Branding?</Link>
                                    </div>
                                </div>

                                <div className="landing-footer-link-box">
                                    <h6>Community and Partners</h6>
                                    <div className="landing-footer-link-list">
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Open Company</Link>
                                    </div>
                                </div>
                            </div>

                            <div className="landing-footer-col">
                                <div className="landing-footer-link-box">
                                    <h6>Solutions</h6>
                                    <div className="landing-footer-link-list">
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Employer Branding</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Reviews</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Insights</Link>
                                        <Link to="/pricing" className="navigation-link decoration-link landing-footer-link">Features & Pricing</Link>
                                    </div>
                                </div>
                            </div>

                            <div className="landing-footer-col">
                                <div className="landing-footer-link-box">
                                    <h6>Support</h6>
                                    <div className="landing-footer-link-list">
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Technical Support</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Metropolis Basic</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Employer Centre Basic</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Manage Company Reviews</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Manage Company Profile</Link>
                                    </div>
                                </div>
                            </div>

                            <div className="landing-footer-col">
                                <div className="landing-footer-link-box">
                                    <h6>Resource Library</h6>
                                    <div className="landing-footer-link-list">
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Hiring and Recruiting</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Employee Onboarding</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Employee Retention and Benefits</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">How to Use Metropolis</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">HR Management and Planning</Link>
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Employer Blog</Link>
                                    </div>
                                </div>
                            </div>

                            <div className="landing-footer-col">
                                <div className="landing-footer-link-box">
                                    <h6>Contact Us</h6>
                                    <div className="landing-footer-link-list">
                                        <Link to="/coming-soon" className="navigation-link decoration-link landing-footer-link">Metropolis Support</Link>
                                        <a href="https://help.metropolis.com/Employer/" rel="noreferrer" className="navigation-link decoration-link landing-footer-link">help.metropolis.com/Employer/</a>
                                        <a href="mailto:support@metropolis.tech" rel="noreferrer" className="navigation-link decoration-link landing-footer-link py-1">
                                            <span className="flex-center flex-auto-0 contain-image mr-2">{SVGicon.mtpIconContactEmail}</span>
                                            <span> support@metropolis.tech </span>
                                        </a>
                                        <a href="tel:4047770098" rel="noreferrer" className="navigation-link decoration-link landing-footer-link">
                                            <span className="flex-center flex-auto-0 contain-image mr-2">{SVGicon.mtpIconContactPhone}</span>
                                            <span>4047770098</span>
                                        </a>
                                    </div>
                                </div>

                                <div className="landing-footer-link-box">
                                    <h6>Follow Us</h6>
                                    <div className="landing-footer-social-link-list">
                                        <a href="https://www.facebook.com/MetropolisAI" target="_blank" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">
                                            {SVGicon.mtpIconSocialFacebook}
                                        </a>
                                        <a href="https://www.twitter.com/MetropolisTech" target="_blank" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">
                                            {SVGicon.mtpIconSocialTwitter}
                                        </a>
                                        <a href="https://www.instagram.com/metropolis.tech" target="_blank" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">
                                            {SVGicon.mtpIconSocialInstagram}
                                        </a>
                                        <a href="https://www.linkedin.com/company/51719281" target="_blank" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">
                                            {SVGicon.mtpIconSocialLinkedIn}
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className="landing-footer-legacy-link">
                            <Link to="/" className="landing-footer-logo flex-center flex-auto-0 contain-image">
                                < img src={LogoWithoutText} alt="footer-logo" />
                            </Link>
                            <p className="mb-0">Looking for <Link to="/" className="navigation-link decoration-link"> Metropolis.com</Link>?</p>
                        </div>
                    </div>
                </div>

                <div className="landing-footer-copyright-bar">
                    <div className="mtp-container">
                        <div className="landing-footer-copyright-flex-contents">
                            <p className="landing-footer-copyright-texts">Copyright © 2008-2022, Metropolis, Inc. “Metropolis” and logo are proprietary trademarks of Metropolis, Inc.</p>

                            <p className="landing-footer-copyright-link-group">
                                <Link to="/termsOfUse" className="navigation-link decoration-link landing-footer-link">Terms of Use</Link>
                                &nbsp;&nbsp;|&nbsp;&nbsp;
                                <Link to="/termsOfUse" className="navigation-link decoration-link landing-footer-link">Privacy & Cookies</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}